import {colors} from '../../../DataTable/defaultSettings';
import {clearfix, colors as xdColors} from '@xpertdox_js/xdstyle';

export default {
  clearfix: clearfix,
  container: {
    fontSize: '1.4rem',
    color: xdColors.black,
  },
  title: {
    ...clearfix,
    borderBottom: '1px solid rgba(0,0,0,0.18)',
    padding: '8px',
    background: xdColors.xdDarkBlue,
    color: '#fff',
  },
  titleText: {
    margin: 0,
    fontSize: '2rem',
  },
  content: {
    padding: '12px 8px',
    background: colors.bg.panel,
    overflowY: 'auto'
  },
  subTitle: {
    fontSize: '1.4rem',
    margin: '10px 0',
    color: colors.xdDarkBlue,
    marginRight: '10px',
  },
  list: {
    listStyle: 'none',
    background: 'rgba(0,0,0,0.025)',
    padding: '8px 6px',
    borderRadius: '4px',
    boxShadow: 'inset 0 1px 4px rgba(36,0,48,0.14)',
    maxHeight: '20%',
    overflowY: 'auto',
  },
  listItem: {
    userSelect: 'auto',
    background: '#fff',
    boxShadow: '0 1px 3px rgba(36,0,48,0.2)',
    padding: '4px',
    fontSize: '1.2rem',
    margin: '3px 0',
    // border: '1px solid ' + xdColors.xdDarkBlue,
    borderLeft: '2px solid ' + xdColors.xdDarkBlue,
    display: 'inline-block',
    marginRight: '10px'
  },
  message: {
    padding: '0 4px',
    fontSize: '1.6rem',
  }
}
